import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./Mainpage.css";
import SidebarLeft from "../elements/SidebarLeft";
import SidebarRight from "../elements/SidebarRight";
import CentralContent from "./CentralContent";
import AuthForm from "./AuthForm";

function MainPage() {
  return (
    <div className="mainpage">
      <Router>
        <SidebarLeft />
        <Switch>
          <Route exact path="/">
            <CentralContent />
          </Route>

          <Route exact path="/users/:username">
            <CentralContent />
          </Route>

          <Route exact path="/hashtags/:hashtag">
            <CentralContent />
          </Route>

          <Route exact path="/signup">
            <AuthForm title="Signup" />
          </Route>

          <Route exact path="/login">
            <AuthForm title="Login" />
          </Route>
        </Switch>
        <SidebarRight />
      </Router>
    </div>
  );
}

export default MainPage;
